export default __webpack_public_path__ + "static/media/10_papugi.46680766.webp";